<template>
    <el-row id="statistics-row">
        <el-col :span="2">
            <el-statistic title="Projects" :value="props.projectsCount"/>    

            <!-- <el-card>
                <div slot="header" class="clearfix">
                    <span>Statistics</span>
                </div>
                <div>
                    <p>Number of projects: 0</p>
                    <p>Number of test cases: 0</p>
                    <p>Number of steps: 0</p>
                </div>
            </el-card> -->
        </el-col>
        <el-col :span="2">
            <el-button @click="logout">Log Out</el-button>

        </el-col >

    </el-row>
</template>

<script setup lang="ts">

import { useAuth } from "@/services/use-auth";

const props = defineProps([
  'projectsCount'
])

const emit = defineEmits([
  'logout'
])

const logout = () => {
  console.log("logging out")
  emit('logout', true)
  useAuth().logout()
}

</script>

<style scoped>
#statistics-row {
    align-items: center; 
    justify-content: space-between; 
    padding-top: 15px;
    padding-bottom: 15px;
}
</style>